/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WorkFlowProtocolLog from './work-flow-protocol-log';
import WorkFlowProtocolLogDetail from './work-flow-protocol-log-detail';
import WorkFlowProtocolLogUpdate from './work-flow-protocol-log-update';
import WorkFlowProtocolLogDeleteDialog from './work-flow-protocol-log-delete-dialog';

const WorkFlowProtocolLogRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WorkFlowProtocolLog />} />
    <Route path="new" element={<WorkFlowProtocolLogUpdate />} />
    <Route path=":id">
      <Route index element={<WorkFlowProtocolLogDetail />} />
      <Route path="edit" element={<WorkFlowProtocolLogUpdate />} />
      <Route path="delete" element={<WorkFlowProtocolLogDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WorkFlowProtocolLogRoutes;
